import { useEffect } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import { SUPPLY_CHAIN_DASHBOARD_URL } from "../config/urls";

export default function SupplyChain() {
  useEffect(() => {
    window.location.assign(SUPPLY_CHAIN_DASHBOARD_URL);
  }, []);

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: "60vh",
        display: "grid",
        placeItems: "center",
        py: 6,
      }}
    >
      <Stack spacing={2.5} alignItems="center" textAlign="center">
        <CircularProgress size={36} />
        <Box>
          <Typography component="h1" variant="h5" sx={{ fontWeight: 700 }}>
            Opening Supply Chain
          </Typography>
          <Typography color="text.secondary" sx={{ mt: 1 }}>
            You are being redirected to the Supply Chain dashboard.
          </Typography>
        </Box>
        <Button
          component="a"
          href={SUPPLY_CHAIN_DASHBOARD_URL}
          variant="contained"
        >
          Continue to dashboard
        </Button>
      </Stack>
    </Container>
  );
}
